import {Auth} from "aws-amplify";
import axios, {AxiosInstance} from "axios";
import aws_config from '../modified_aws-export';

let axiosInstance: AxiosInstance | null = null;

const createAxiosInstance = async (): Promise<AxiosInstance> => {
  if (!axiosInstance) {
    try {
      const currentSession = await Auth.currentSession();
      axiosInstance = axios.create({
        baseURL: `${aws_config.vectorization_apigateway_url}api/v1/vectorizations`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentSession
              .getAccessToken()
              .getJwtToken()}`,
        },
      });
    } catch (error) {
      console.error("Error creating Axios instance:", error);
      throw new Error("Authentication required or token retrieval failed.");
    }
  }
  return axiosInstance;
};

export default createAxiosInstance;
